/* tslint:disable */
/* eslint-disable */

/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export * from './AppMarketingData';
export * from './BrandEnum';
export * from './CarManufacturer';
export * from './CarModelBodyType';
export * from './CarModelSimple';
export * from './CarModelVehicleType';
export * from './CheckRegistrationRequest';
export * from './CheckRegistrationResponse';
export * from './Countries';
export * from './DeleteDriverRegistrationDocumentRequest';
export * from './DriverPortalRegistrationFormFields';
export * from './DriverPortalRegistrationRequiredTaxiLicencePerType';
export * from './DriverRegistrationDocumentsSetItem';
export * from './DriverRegistrationInput';
export * from './DriverRegistrationLogCreatedVia';
export * from './DriverRegistrationLogFlowType';
export * from './DriverRegistrationLogLastStep';
export * from './DriverRegistrationLogLicenseTypeSelection';
export * from './DriverRegistrationLogResponse';
export * from './DriverRegistrationLogResponseWithCompanyData';
export * from './DriverRegistrationLogSource';
export * from './DriverRegistrationLogStatus';
export * from './DriverRegistrationLogType';
export * from './FleetUploadedDocument';
export * from './FormCity';
export * from './FormCityMinimal';
export * from './FormCountry';
export * from './FormCountryMinimal';
export * from './FormLanguage';
export * from './GetCarModelsGroupedByManufacturerResponse';
export * from './GetDriverPortalRegistrationFormFieldsResponse';
export * from './GetDriverRegistrationCarModelsResponse';
export * from './GetDriverRegistrationDocumentUrlResponse';
export * from './GetDriverRegistrationDocumentsSetResponse';
export * from './GetDriverRegistrationFormDataResponse';
export * from './GetDriverRegistrationMinimalFormDataResponse';
export * from './InAppSignup';
export * from './PaymentFormFields';
export * from './PaymentFormResponse';
export * from './PaymentSwiftOption';
export * from './RegisterRequest';
export * from './RegisterWithMarketingRequest';
export * from './RegistrationPaymentDetailsType';
export * from './RegistrationPaymentTypeConfig';
export * from './RegistrationPaymentTypeConfigs';
export * from './StandardRequest';
export * from './SubmittedDriverRegistrationLogResponse';
export * from './VisitorTrackingData';
export * from './WebMarketingData';
